export const UPDATE_COLORS = 'theme/UPDATE_COLORS';
export const UPDATE_FONTS = 'theme/UPDATE_FONTS';
export const UPDATE_TOUCH_DEVICE = 'theme/UPDATE_TOUCH_DEVICE';
